{
  "level": "melev",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:melev",
    "objects": "AREAS.E3:melev.e3",
    "mesh": "TREES.E3:melev.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 10.0,
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        20.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -0.0,
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        0.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "C:\\EDITOR\\simpleLW.lwo",
      "entity_class": "C:\\EDITOR\\simpleLW.lwo",
      "piece_name": "",
      "offset": 54,
      "centroid": [
        -3.3333333333333335,
        0.0,
        6.666666666666667
      ],
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        20.0
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 20.0,
        "height_z": 20.0,
        "door_width": 20.0,
        "door_depth": 20.0,
        "leaf_depth": 20.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          -0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -10.0,
          -10.0,
          0.0
        ],
        [
          -10.0,
          10.0,
          20.0
        ],
        [
          -10.0,
          -10.0,
          20.0
        ],
        [
          -10.0,
          10.0,
          0.0
        ],
        [
          10.0,
          -10.0,
          0.0
        ],
        [
          10.0,
          10.0,
          0.0
        ]
      ],
      "plane_distance": 10.0
    },
    {
      "tag": "CSlidingDoor piece: melevdr3",
      "entity_class": "CSlidingDoor",
      "piece_name": "melevdr3",
      "offset": 554,
      "centroid": [
        -3468.0,
        -4909.50048828125,
        1086.70703125
      ],
      "bbox_min": [
        -3471.0,
        -4910.00048828125,
        1081.70703125
      ],
      "bbox_max": [
        -3465.0,
        -4909.00048828125,
        1091.70703125
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 1.0,
        "height_z": 10.0,
        "door_width": 6.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3471.0,
          -4910.00048828125,
          1081.70703125
        ],
        [
          -3465.0,
          -4910.00048828125,
          1081.70703125
        ],
        [
          -3471.0,
          -4909.00048828125,
          1081.70703125
        ],
        [
          -3465.0,
          -4909.00048828125,
          1081.70703125
        ],
        [
          -3471.0,
          -4910.00048828125,
          1091.70703125
        ],
        [
          -3465.0,
          -4910.00048828125,
          1091.70703125
        ],
        [
          -3465.0,
          -4909.00048828125,
          1091.70703125
        ],
        [
          -3471.0,
          -4909.00048828125,
          1091.70703125
        ]
      ],
      "plane_distance": 3465.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "CSlidingDoor piece: melevdr1",
      "entity_class": "CSlidingDoor",
      "piece_name": "melevdr1",
      "offset": 1546,
      "centroid": [
        -3468.0,
        -4909.50048828125,
        1036.70703125
      ],
      "bbox_min": [
        -3471.0,
        -4910.00048828125,
        1031.70703125
      ],
      "bbox_max": [
        -3465.0,
        -4909.00048828125,
        1041.70703125
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 1.0,
        "height_z": 10.0,
        "door_width": 6.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3465.0,
          -4910.00048828125,
          1031.70703125
        ],
        [
          -3465.0,
          -4909.00048828125,
          1031.70703125
        ],
        [
          -3465.0,
          -4910.00048828125,
          1041.70703125
        ],
        [
          -3465.0,
          -4909.00048828125,
          1041.70703125
        ],
        [
          -3471.0,
          -4910.00048828125,
          1041.70703125
        ],
        [
          -3471.0,
          -4910.00048828125,
          1031.70703125
        ],
        [
          -3471.0,
          -4909.00048828125,
          1031.70703125
        ],
        [
          -3471.0,
          -4909.00048828125,
          1041.70703125
        ]
      ],
      "plane_distance": -4910.0005,
      "authentic_texture": "cbaseelevdoor"
    },
    {
      "tag": "CSlidingDoor piece: melevdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "melevdr2",
      "offset": 6397,
      "centroid": [
        -3468.0,
        -4909.50048828125,
        1062.70703125
      ],
      "bbox_min": [
        -3471.0,
        -4910.00048828125,
        1057.70703125
      ],
      "bbox_max": [
        -3465.0,
        -4909.00048828125,
        1067.70703125
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 1.0,
        "height_z": 10.0,
        "door_width": 6.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -3471.0,
          -4910.00048828125,
          1057.70703125
        ],
        [
          -3465.0,
          -4910.00048828125,
          1057.70703125
        ],
        [
          -3465.0,
          -4909.00048828125,
          1057.70703125
        ],
        [
          -3471.0,
          -4909.00048828125,
          1057.70703125
        ],
        [
          -3465.0,
          -4910.00048828125,
          1067.70703125
        ],
        [
          -3471.0,
          -4910.00048828125,
          1067.70703125
        ],
        [
          -3465.0,
          -4909.00048828125,
          1067.70703125
        ],
        [
          -3471.0,
          -4909.00048828125,
          1067.70703125
        ]
      ],
      "plane_distance": -3471.0,
      "authentic_texture": "doorjam"
    },
    {
      "tag": "C:\\EDITOR\\simpleLW.lwo",
      "entity_class": "C:\\EDITOR\\simpleLW.lwo",
      "piece_name": "",
      "offset": 7216,
      "centroid": [
        -3.3333333333333335,
        0.0,
        6.666666666666667
      ],
      "bbox_min": [
        -10.0,
        -10.0,
        0.0
      ],
      "bbox_max": [
        10.0,
        10.0,
        20.0
      ],
      "dimensions_source": {
        "span_x": 20.0,
        "span_y": 20.0,
        "height_z": 20.0,
        "door_width": 20.0,
        "door_depth": 20.0,
        "leaf_depth": 20.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          -0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -10.0,
          -10.0,
          0.0
        ],
        [
          -10.0,
          10.0,
          20.0
        ],
        [
          -10.0,
          -10.0,
          20.0
        ],
        [
          -10.0,
          10.0,
          0.0
        ],
        [
          10.0,
          -10.0,
          0.0
        ],
        [
          10.0,
          10.0,
          0.0
        ]
      ],
      "plane_distance": 10.0
    }
  ],
  "tutorial_messages": []
}